import {
  Anchor,
  Button,
  Container,
  Grid,
  Image,
  Paper,
  Text,
  TextInput,
  Title,
} from '@mantine/core';
import { joiResolver, useForm } from '@mantine/form';
import { showNotification } from '@mantine/notifications';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { Check, X } from 'tabler-icons-react';
import axios from '../../../api/axios';
import { ErrorResponse } from '../../../type/error-response.types';
import { ForgetPasswordSchema } from './schema/forget-password.schema';

const ForgetPasswordPage = () => {
  const form = useForm({
    initialValues: {
      username: '',
      email: '',
    },
    validate: joiResolver(ForgetPasswordSchema),
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const validate = (value: string) => {
    if (value.length === 0) {
      return 'This field is required.';
    }
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      await axios.post('/web/auth/forgot_password', {
        username: form.values.username,
        email: form.values.email,
      });

      showNotification({
        id: 'successfully-sent-forget-password',
        message:
          'Successfully sent forget password link. Please check your email.',
        icon: <Check size={16} />,
        color: 'teal',
        autoClose: 6000,
      });
    } catch (err: any) {
      const error: ErrorResponse = err.response?.data;

      showNotification({
        id: 'failed-to-send-forget-password',
        message:
          error?.error || err?.response?.data || 'An Unexpected Error Occurred',
        icon: <X size={16} />,
        color: 'red',
        autoClose: 10000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>XPAY.World - Password reset</title>
      </Helmet>
      <Container
        fluid
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <Paper
          shadow='xs'
          p='xl'
          mx='auto'
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            maxWidth: 400,
          }}
        >
          <Paper mb='sm'>
            <Image src='/images/lock-icon.svg' />
          </Paper>
          <Title order={2} mb='sm'>
            Forgot your password?
          </Title>
          <Text align='center' color='gray' size='sm' mb='sm'>
            Enter your email and username and we'll <br /> send you a link to
            reset your password
          </Text>
          <form onSubmit={form.onSubmit(handleSubmit)}>
            <Grid>
              <Grid.Col>
                <TextInput
                  label='Username'
                  placeholder='Username'
                  {...form.getInputProps('username')}
                />
              </Grid.Col>
              <Grid.Col>
                <TextInput
                  label='Email'
                  placeholder='Email'
                  {...form.getInputProps('email')}
                />
              </Grid.Col>
              <Grid.Col>
                <Button type='submit' loading={isLoading} fullWidth>
                  Send password reset link
                </Button>
              </Grid.Col>
              <Grid.Col>
                <Anchor
                  component='button'
                  type='button'
                  color='gray'
                  onClick={() => {
                    navigate('/login');
                  }}
                  size='xs'
                >
                  Back to login
                </Anchor>
              </Grid.Col>
            </Grid>
          </form>
        </Paper>
      </Container>
    </>
  );
};

export default ForgetPasswordPage;
